var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EffectComponent',{key:_vm.$vnode.key,attrs:{"name":_vm.module.name,"enabled":_vm.object.settings.enabled},on:{"toggled":_vm.enabled}},[_c('CountdownWidget',{attrs:{"creative":_vm.creative,"item":_vm.object.settings},on:{"change":_vm.changeHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }